var _a, _b;
import { prodChains, prodParasKusama, prodParasPolkadot, prodRelayKusama, prodRelayPolkadot } from './endpoint_dump';
export var Ecosystem;
(function (Ecosystem) {
    Ecosystem["Polkadot"] = "Polkadot";
    Ecosystem["Kusama"] = "Kusama";
    Ecosystem["None"] = "None";
})(Ecosystem || (Ecosystem = {}));
export const allChains = [];
const addChain = (e, ecosystem) => allChains.push({ name: e.text, ecosystem, endpoints: e.providers });
// Polkadot stuff
addChain(prodRelayPolkadot, Ecosystem.Polkadot);
(_a = prodRelayPolkadot.linked) === null || _a === void 0 ? void 0 : _a.forEach((e) => addChain(e, Ecosystem.Polkadot));
// Kusama stuff
addChain(prodRelayKusama, Ecosystem.Kusama);
(_b = prodRelayKusama.linked) === null || _b === void 0 ? void 0 : _b.forEach((e) => addChain(e, Ecosystem.Kusama));
// everything else.
prodChains.forEach((e) => addChain(e, Ecosystem.None));
export function paraIdToName(id, ecosystem) {
    if (ecosystem == Ecosystem.Kusama) {
        const maybeChain = prodParasKusama.find((c) => {
            if (c.paraId && c.paraId === id) {
                return true;
            }
        });
        return maybeChain ? maybeChain.text : undefined;
    }
    else if (ecosystem == Ecosystem.Polkadot) {
        const maybeChain = prodParasPolkadot.find((c) => {
            if (c.paraId && c.paraId === id) {
                return true;
            }
        });
        return maybeChain ? maybeChain.text : undefined;
    }
    else {
        return undefined;
    }
}
